/* eslint-disable */

import { Money } from '@ap/interface-bspc-core';

export interface LijstVanProducten {
    producten: Product[];
}

export interface LijstVanProductGroepen {
    is_beschikbaar: boolean;
    productgroepen: ProductGroep[];
}

export interface ZelfRegelenDetails {
    automatische_afschrijving_toegestaan?: boolean;
    digicode_id?: string;
    heeft_afbetaalde_rekening: boolean;
    heeft_betaalpas: boolean;
    heeft_bizcuit_koppeling: boolean;
    heeft_digipas: boolean;
    heeft_digicode: boolean;
    heeft_huismap?: boolean;
    heeft_ontbrekende_productgroep?: boolean;
    heeft_toegang_tot_kind_rekeningen: boolean;
    huismap_type?: HuismapType;
    hypotheek_aflosvormen?: Aflosvorm[];
    is_meerderjarig: boolean;
    kan_hypotheek_extra_storten: boolean;
    kan_nieuwe_betaalpas_aanvragen: boolean;
    mag_aflossingsvrij_hypotheek_omzetten: boolean;
    mag_ideal_profiel_aanmaken?: boolean;
    productgroepen: ProductGroep[];
    aantal_ecommerce_authenticaties? : string;
}

export interface Product {
    account_id?: string;
    adressen?: Adres[];
    aantal_geweigerde_opdrachten?: string;
    aantal_nieuwe_berichten?: string;
    aantal_te_verzenden_opdrachten?: string;
    capability_product_group?: string
    externe_betaling_toegestaan?: boolean;
    heeft_huismap?: boolean;
    heeft_spaarpotten?: boolean;
    huismap_type?: HuismapType;
    hypotheekbedrag?: Money;
    id?: string;
    ideal_toegestaan?: boolean;
    incasso_machtiging?: boolean;
    interne_betaling_toegestaan?: boolean;
    is_beschikbaar: boolean;
    kan_hypotheek_extra_aflossen?: boolean;
    lening_bedrag?: Money;
    lening_bedrag_restant?: Money;
    naam?: string;
    product_features?: ProductFeature[];
    productgroep: ProductGroep;
    rekening_weergeven?: boolean;
    rekeninghouder?: string;
    rekeningnummer?: string;
    rekeningsoort: RekeningsoortType;
    rol?: Rol;
    roodstand_sinds?: string;
    saldo?: Money;
    saldo_hoofdsom?: Money;
    saldo_portefeuille?: Money;
    saldo_totaal?: Money;
    spaarpotten?: Spaarpot[];
    spaarpotten_toegestaan?: boolean;
    toegekende_naam?: string;
    transactievertraging?: boolean;
    zekerheidnummer?: number;
}

export interface HuismapResult {
    huismap_type: HuismapType;
}

export enum HuismapType {
    PEGA = 'pega',
    MIJN = 'mijn'
}

export enum RekeningsoortType {
    LENING = 'lening',
    BOUWDEPOT = 'bouwdepot',
    BATCHBETALING = 'batchbetaling',
    OVERIG = 'overig'
}

export interface Spaarpot {
    afbeelding?: string;
    doelbedrag?: Money;
    eindigt_op?: string;
    id?: string;
    is_hoofdspaarpot?: boolean;
    naam?: string;
    saldo?: Money;
}

export interface Adres {
    huisnummer?: string;
    huisnummer_toevoeging?: string;
    onderpandnummer?: number;
    plaats?: string;
    postcode?: string;
    straat?: string;
}

export interface OpenstaandeOpdrachten {
    aantal_geweigerde_opdrachten: string;
    aantal_te_verzenden_opdrachten: string;
}

export interface ContractDetails {
    gebruik_rekening_filter?: boolean;
    is_zakelijk: boolean;
    is_zzp: boolean;
}

export enum ProductGroep {
    BELEGGEN = 'beleggen',
    BETALEN_LENEN = 'betalen_lenen',
    HYPOTHEKEN = 'hypotheken',
    SPAREN = 'sparen',
    VERZEKEREN = 'verzekeren',
    OVERIG = 'overig',
    ONBEKEND = 'onbekend'
}

export enum Rol {
    WETTELIJK_VERTEGENWOORDIGER = 'wettelijk_vertegenwoordiger',
    GEMACHTIGDE = 'gemachtigde',
    ALS_BEHEREND_VOOR = 'als_beherend_voor',
    REKENINGHOUDER = 'rekeninghouder',
    MEDEREKENINGHOUDER = 'mederekeninghouder',
    MEEKIJK_GEMACHTIGDE = 'meekijk_gemachtigde',
    BEVOEGD_TOT_INTERNET_BANKIEREN = 'bevoegd_tot_internet_bankieren',
    ANDERS = 'anders'
}

export enum ProductFeature {
    FONDS_BELEGGEN = 'fonds_beleggen',
    RETOUR_RENTE_MELDING = 'retour_rente_melding',
    IDEAL_TOEGESTAAN = 'ideal_toegestaan',
    HYPOTHEEK_BELEGGINGS_REKENING = 'hypotheek_beleggings_rekening',
    DEBET_RENTE_KWIJTSCHELDING = 'debet_rente_kwijtschelding',
    KASBOEK_SPAARPOTTEN = 'kasboek_spaarpotten',
    INCASSO_MACHTIGING = 'incasso_machtiging',
    OVERBOEKEN_NAAR_NIET_TOEGESTAAN = 'overboeken_naar_niet_toegestaan',
    WIJZIGEN_TEGENREKENING_NIET_TOEGESTAAN = 'wijzigen_tegenrekening_niet_toegestaan',
    CONSTRUCTION_DEPOT = 'construction_depot',
    ZZP_PRODUCT = 'zzp_product',
    PERSONAL_LOAN = 'personal_loan',
    BRIDGING_LOAN = 'bridging_loan',
    ONBEKEND = 'onbekend'
}

export enum Aflosvorm {
    ANNUITEIT = 'annuiteit',
    LINEAIR = 'lineair',
    SPAAR_PLUS = 'spaar_plus',
    DEPOT = 'depot',
    RENDEMENT = 'rendement',
    PERSOONLIJK_VERMOGENS_POLIS = 'persoonlijk_vermogens_polis',
    AFLOSSINGVRIJ = 'aflossingvrij',
    EXTRA_RUIMTE_A = 'extra_ruimte_a',
    EXTRA_RUIMTE_B = 'extra_ruimte_b',
    NETTO_LASTEN = 'netto_lasten',
    MANAGED_ACCOUNT = 'managed_account',
    EXTRA_INKOMEN = 'extra_inkomen',
    DUURZAME_ASN_FONDSEN = 'duurzame_asn_fondsen',
    SPAARREKENING = 'spaarrekening',
    BELEGGINGS_REKENING = 'beleggings_rekening',
    EFFECTEN = 'effecten',
    LEVEN = 'leven',
    PENSIOEN_OPTIMAAL = 'pensioen_optimaal',
    DUURZAME_ANNUITEIT = 'duurzame_annuiteit',
    DUURZAAM_LINEAIR = 'duurzaam_lineair',
    SPAARHYPOTHEEK = 'spaarhypotheek',
    SPAARPLAN = 'spaarplan',
    UNIVERSAL_LIFE = 'universal_life',
    NAVIGATIE = 'navigatie',
    PARTICIPATIE_PLAN = 'participatie_plan',
    BELEGGING = 'belegging',
    FORTUIN_PLAN = 'fortuin_plan',
    PERSOONLIJK_VERMOGEN_POLIS = 'persoonlijk_vermogen_polis',
    KAPITAAL_GROEI_PLAN = 'kapitaal_groei_plan',
    OVERIG = 'overig'
}
